import React, { Component } from "react";
import { connect } from "react-redux";
import SimulationContent from "../SimulationContent"
import { getAdsSignalMap, getContrAndDeviceInfo } from "../../../services/Andes_v2/endToEndChannel";
import { END_TO_END_CHANNEL } from "../../../constants/treeConstants";
import { updateEndToEndHSPICEConfig, updateEndToEndHspiceConfigStatus } from "../store/endToEndChannel/action";

class HspiceSimulation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controllerInfo: {},
      deviceInfo: {},
      contrPCBIndex: -1,
      devicePCBIndex: -1,
      controllerICComps: [],
      deviceICComps: []
    }
  }

  componentDidMount = async () => {
    await this.setData();
  }

  componentDidUpdate = async (prevProps) => {
    const { hspiceConfigStatus, endToEndChannelId } = this.props;
    if ((hspiceConfigStatus && prevProps.hspiceConfigStatus !== hspiceConfigStatus)
      || (endToEndChannelId !== prevProps.endToEndChannelId)) {
      await this.setData();
    }
  }
  setData = async () => {
    const { hspiceConfig, pcbConnections = [], connections = [] } = this.props;
    const {
      controllerInfo,
      deviceInfo,
      contrPCBIndex,
      devicePCBIndex,
      controllerICComps,
      deviceICComps
    } = await getContrAndDeviceInfo({ config: hspiceConfig, pcbConnections, connections });

    this.setState({
      controllerInfo,
      deviceInfo,
      contrPCBIndex,
      devicePCBIndex,
      controllerICComps,
      deviceICComps
    })
  }

  render() {
    const { pcbConnections = [], connections = [] } = this.props;
    const { controllerInfo, deviceInfo, controllerICComps, deviceICComps, contrPCBIndex, devicePCBIndex } = this.state;

    const signal_map = getAdsSignalMap({ pcbConnections, connections });
    return <SimulationContent
      {...this.props}
      controllerICComps={controllerICComps}
      deviceICComps={deviceICComps}
      signals={signal_map}
      contrPCBIndex={contrPCBIndex}
      devicePCBIndex={devicePCBIndex}
      controllerInfo={controllerInfo}
      deviceInfo={deviceInfo}
      channelType={END_TO_END_CHANNEL}
      setData={this.setData}
    />
  }
}

const mapState = (state) => {
  const {
    endToEndChannel: {
      endToEndChannelInfo: { content = {}, hspiceConfig, type, id },
      hspiceConfigStatus
    },
    library: { libraryStatus }
  } = state.AndesV2Reducer;
  const {
    pcbConnections = [],
    connections = [],
    simulationSolver
  } = content;

  return {
    pcbConnections,
    connections,
    hspiceConfig,
    endToEndChannelId: id,
    serdesType: type,
    libraryStatus,
    simulationSolver,
    hspiceConfigStatus
  }
};

const mapDispatch = (dispatch) => ({
  _updateHSPICEConfig(hspiceConfig) {
    dispatch(updateEndToEndHSPICEConfig(hspiceConfig));
  },
  _updateHspiceConfigStatus(status) {
    dispatch(updateEndToEndHspiceConfigStatus(status));
  },
});

export default connect(mapState, mapDispatch)(HspiceSimulation);